import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {TermsConditionsEffects} from '@app/cart/store/effects/terms-conditions.effects';
import {termsAndConditionsReducer} from '@app/cart/store/reducers/terms-conditions.reducer';
import {termsAndConditionsFeatureKey} from '@app/cart/store/selectors/terms-conditions.selectors';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {I18nModule, UrlModule} from '@spartacus/core';
import {TermsAndConditionsComponent} from './terms-and-conditions.component';

import '@sapudex/web-components/dist/Link.js';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    UrlModule,
    StoreModule.forFeature(termsAndConditionsFeatureKey, termsAndConditionsReducer),
    EffectsModule.forFeature([TermsConditionsEffects]),
    RouterModule,
    FormsModule,
    TermsAndConditionsComponent,
  ],
  exports: [TermsAndConditionsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TermsAndConditionsModule {}
